import { LocationAPIResult } from "../services/location/models/location-result";
import { RegionAPIResult } from "../services/location/models/region-result";

export const getLocationApiResult = (locationResponse: LocationAPIResult): RegionAPIResult => {
  const response = locationResponse?.data;
  return {
    city: response?.city,
    country: response?.countryName,
    countryCode: response?.country ? response.country.toUpperCase() : '',
    region: response?.region,
    group: response?.group,
    channel: response?.channel,
  };
};
